import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import "./style.scss";
import { MenuItem } from "../../@types/stores/menu";
import { useParams } from "react-router";
import menuStore from "../../stores/menu";
import FooterForGroups from "../../components/FooterForGroups";
import { OrderLine } from "../../@types/stores/order";
import { v4 as guid } from 'uuid';
import orderStore from "../../stores/order";
import OrderIdle from "../../components/OrderIdle";
import AdditionalSellUnits from "../../components/AdditionalSellUnits";
import {uniqArray} from "../../helpers/ApiHelper";

const AdditionalSellUnitPage = () => {
    let params = useParams();

    const [item, setItem] = useState<MenuItem>();
    const [skipRecommendations, setSkipRecommendations] = useState<boolean>(false);

    useEffect(() => {
        getItem(params.number);
    }, [params.number]);

    const getItem = async (number: string | undefined) => {
        // Menu article
        if (typeof params.category !== "undefined") {
            if (!menuStore.menu) {
                await menuStore.getMenu();

                const category = params.category ? +params.category : 0;
                menuStore.changeCategory(category);

                const subCategory = params.subCategory ? +params.subCategory : 0;
                menuStore.changeSubCategory(subCategory);
            }

            if (number) {
                const _item = menuStore.getItemByNumber(number);
                if (_item) {
                    setItem(_item);
                    menuStore.changeMenuItem(_item.id);

                    if (!orderStore.currentOrderLine) {
                        const currentOrderLine: OrderLine = {
                            id: guid(),
                            menuId: menuStore.navigation.category,
                            subMenuId: menuStore.navigation.subCategory,
                            name: _item.name,
                            number: _item.number,
                            count: 1,
                            price: _item.price,
                            total: _item.price,
                            img: _item.previewList
                        }
                        orderStore.setCurrentOrderLine = currentOrderLine;
                    }
                }
            }
        }

        // Recommendation article
        if (typeof params.groupId !== "undefined") {
            const groupId = params.groupId && !isNaN(+params.groupId) ? +params.groupId : 0;
            if (groupId && number) {
                const _item = menuStore.getRecommendationItemByNumber(groupId, number);
                if (_item) {
                    setItem(_item);
                    setSkipRecommendations(true);

                    const currentOrderLine: OrderLine = {
                        id: guid(),
                        recommendationGroupId: groupId,
                        name: _item.name,
                        number: _item.number,
                        count: 1,
                        price: _item.price,
                        total: _item.price,
                        img: _item.previewList
                    }
                    orderStore.setCurrentOrderLine = currentOrderLine;
                }
            }
        }
    }

    if (!item?.additionalSellUnits) return null;

    return <div className="AdditionalSellUnitPage">
        <Header />
        {item
            ? <AdditionalSellUnits sellUnits={uniqArray(item.additionalSellUnits, "price")} item={item} skipRecommendations={skipRecommendations} />
            : null
        }
        <FooterForGroups />
        <OrderIdle />
    </div>
}

export default AdditionalSellUnitPage;
